import { memo, useContext, useEffect, useState } from "react";
import Breadcrumb from "components/shared/breadcrumb";
import Selectbox from "components/shared/inputs/selectbox";
import EnumsContext from "context/initialize-context";
import { useLocation, useSearchParams, Link } from "react-router-dom";
import Searchbox from "./searchbox";
import SelectOptions from "./select-options";
import Skeleton from "components/skeleton/table-1";
import convertUtils from "utils/convert-utils";
import Checkbox from "components/shared/inputs/checkbox";
import { contentStatusId, generateIconLink } from "utils";
import BottomSkeleton from "components/skeleton/table-grid-bottom";
import Pagination from "components/shared/pagination";
import PriorityModal from "./priorityModal";
import UseFetch from "hooks/useFetch";

const List = props => {
    const {
        pageData
    } = props;

    const [fetchUrl, setFetchUrl] = useState(null);
    const { isLoading, data, error, mutate } = UseFetch(fetchUrl);
    const [addItems, setAddItems] = useState([]);
    const enumsData = useContext(EnumsContext);
    const [selectedRows, setSelectedRows] = useState([]);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [urlParamsData, setUrlParamsData] = useState({});
    // eslint-disable-next-line
    const [priorityData, setPriorityData] = useState({ show: false });

    useEffect(() => {
        if (searchParams.get("form_id")) {
            let newUrl = `${pageData.index_url}?${searchParams.toString()}`;
            setFetchUrl(newUrl);
        }

        const newUrlParamsData = {};
        for (const [key, value] of searchParams.entries()) {
            newUrlParamsData[key] = value;
        }
        setUrlParamsData(newUrlParamsData);
        // eslint-disable-next-line
    }, [searchParams])

    useEffect(() => {
        if (enumsData.data.forms.length) {
            // set add items
            const newItems = [];

            enumsData.data.forms.forEach(item => {
                if (enumsData.permissions.forms[item.id] && enumsData.permissions.forms[item.id].indexOf(1) !== -1)
                    newItems.push({
                        title: item.title,
                        link: `add/${item.id}?form_id=${item.id}`
                    });
            })

            setAddItems(newItems);
        }
        // eslint-disable-next-line
    }, [enumsData.data.forms, searchParams])

    const selectRowHandler = id => {
        setSelectedRows(prev => {
            if (selectedRows.indexOf(id) !== -1) {
                const newState = prev.filter(rowId => rowId !== id);
                return newState;
            }

            return [...prev, id];
        })
    }

    const createOrEditLink = id => {
        let url = location.pathname;

        if (id)
            url += `/${id}?form_id=${searchParams.get("form_id")}`;

        return url;
    }

    const priorityClickHandler = (id, value) => {
        setPriorityData({
            show: true,
            id,
            value
        })
    }

    return (
        <>
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-5 options-bar">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">{pageData.title}</h1>
                    <Breadcrumb data={pageData.breadcrumb} />
                </div>

                <div className="flex">
                    <button className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center" onClick={mutate} title="بروزرسانی">
                        <i className="fa-regular fa-arrows-retweet"></i>
                    </button>

                    {
                        addItems.length > 0 && (
                            <Selectbox
                                className="c2 tp-24"
                                placeholder="افزودن"
                                loading={enumsData.loading}
                                options={addItems}
                            />
                        )
                    }
                </div>
            </div>

            <div className="wrap-box tp-22">
                <div className="flex justify-between items-start">
                    <Searchbox fields={pageData.search_setting} />

                    <div className="flex options-holder">
                        <SelectOptions
                            pageData={pageData}
                            data={data}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows}
                            reload={mutate}
                            formId={searchParams.get("form_id")}
                        />
                    </div>
                </div>

                {
                    searchParams.get("form_id") ? (
                        <>
                            <div className="table-c1 mt-10 mb-4">
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="w-5"></th>
                                            <th className="w-5"></th>
                                            <th className="w-5"></th>
                                            <th></th>
                                            <th className="w-5"></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {isLoading && <Skeleton />}
                                    </tbody>
                                </table>

                                {
                                    isLoading || (data && data.data?.length) ? (
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className="w-5"></th>
                                                    <th className="w-5"></th>
                                                    <th className="w-5"></th>
                                                    <th></th>
                                                    <th className="w-5"></th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {
                                                    !isLoading ? (
                                                        data.data?.map((item, i) => {
                                                            const hasIcon = pageData.index_setting.icon?.length;
                                                            const labels = [];
                                                            ["label_1", "label_2", "label_3"].forEach(label => {
                                                                const labelObj = pageData.index_setting[label];

                                                                if (labelObj) {
                                                                    const intendedKey = labelObj.key;
                                                                    let value = item.content[intendedKey] || "-";

                                                                    if (labelObj.convert_function)
                                                                        value = convertUtils(labelObj.convert_function, value);

                                                                    labels.push(`${labelObj.label}: ${value}`);
                                                                }
                                                            })

                                                            return (
                                                                <tr key={`table-row-${i}`}>
                                                                    <td>
                                                                        <Checkbox
                                                                            value={selectedRows.indexOf(item.content.id) !== -1}
                                                                            changeHandler={() => selectRowHandler(item.content.id)}
                                                                        />
                                                                    </td>

                                                                    <td>
                                                                        {contentStatusId(item.content.status_id).icon}
                                                                    </td>

                                                                    <td>
                                                                        <Link className="edit" to={createOrEditLink(item.content.id)}>
                                                                            <i className="fa-solid fa-pen-to-square"></i>
                                                                        </Link>
                                                                    </td>

                                                                    <td className={`desc-col${hasIcon ? " has-icn" : ""}`}>
                                                                        {
                                                                            !!hasIcon && (
                                                                                <div className="icn-holder-c1">
                                                                                    {
                                                                                        pageData.index_setting.icon.map((icon, i) => {
                                                                                            const className = {};

                                                                                            if (icon.class)
                                                                                                className.className = icon.class;

                                                                                            return (
                                                                                                <Link
                                                                                                    key={`${i}-icon-${i}`}
                                                                                                    to={generateIconLink(item.content, icon.url)}
                                                                                                    title={icon.title}
                                                                                                    {...className}
                                                                                                >
                                                                                                    <i className={icon.font_icon} />
                                                                                                </Link>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }

                                                                        <div className={`content${hasIcon ? " grow" : ""}`}>
                                                                            <p className="tp-25" data-fn={pageData.index_setting.title.key}>
                                                                                {item.content.group_type === 1 && <i className="fa-regular fa-layer-group ml-2 text-blue-400 z-10" title="دارای فروشنده های دیگر"></i>}

                                                                                {
                                                                                    !!item.content.has_draft && <i className="fa-regular fa-hourglass-clock text-blue-400 ml-2 z-10" title="در انتظار تایید پیش نویس"></i>
                                                                                }

                                                                                {
                                                                                    item.content.virtual_title
                                                                                }
                                                                            </p>

                                                                            <h6 className="tp-26">
                                                                                {
                                                                                    labels.join(" | ")
                                                                                }
                                                                            </h6>

                                                                            {
                                                                                pageData.index_setting.recursive
                                                                                && <Link to={`?parent_id=${item.content.id}&form_id=${searchParams.get("form_id")}`} className="pos-cover"></Link>
                                                                            }
                                                                        </div>
                                                                    </td>

                                                                    <td className="priority-col">
                                                                        {
                                                                            pageData.index_setting.priority && (
                                                                                <button className="noti" onClick={() => priorityClickHandler(item.content.id, item.priority)}>
                                                                                    {item.priority ? <span>{item.priority}</span> : <></>}
                                                                                </button>
                                                                            )
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : <Skeleton />
                                                }
                                            </tbody>
                                        </table>
                                    ) : (
                                        <></>
                                    )
                                }

                                {
                                    !isLoading && data && !data.data?.length && (
                                        <p className="font-medium text-sm text-center mb-10 text-slate-800 dark:text-gray-300">
                                            اطلاعاتی برای نمایش یافت نشد
                                        </p>
                                    )
                                }

                                {
                                    error && <p className="font-medium text-sm text-red-500 text-center">خطا در دریافت اطلاعات!</p>
                                }
                            </div>

                            {
                                isLoading && (
                                    <BottomSkeleton />
                                )
                            }

                            {
                                data && (
                                    <div className="flex justify-between items-center">
                                        <span className="text-[#1d212f] dark:text-[#bdbdca] text-sm font-medium">
                                            {data.count} مورد - {Math.ceil(data.count / (urlParamsData.limit || 10))} صفحه
                                        </span>

                                        {
                                            !!data.data?.length && (
                                                <Pagination
                                                    count={data.count}
                                                    limit={urlParamsData.limit}
                                                    offset={urlParamsData.offset}
                                                />
                                            )
                                        }
                                    </div>
                                )
                            }
                        </>
                    ) : (
                        <div className="table-c1 mt-10 mb-4">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="w-5"></th>
                                        <th className="w-5"></th>
                                        <th className="w-5"></th>
                                        <th></th>
                                        <th className="w-5"></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <Skeleton />
                                </tbody>
                            </table>
                        </div>
                    )
                }
            </div>

            <PriorityModal
                data={priorityData}
                setData={setPriorityData}
                reload={mutate}
                formId={searchParams.get("form_id")}
            />
        </>
    )
}

export default memo(List);